import { render, staticRenderFns } from "./AdminBookingsTentative.vue?vue&type=template&id=4ee9873f"
import script from "./AdminBookingsTentative.vue?vue&type=script&lang=js"
export * from "./AdminBookingsTentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports